<template>
	<div class="page">
		<div class="titleBox">
			<div class="title">订单审核</div>
			<div class="titleR">
				<el-button size="mini" type="warning" style="margin-top:11px;" @click="$router.back()">返回</el-button>
			</div>
		</div>
		<div class="lineBox">
			<div class="box1">
				<div class="tit" style="text-align: center;">倒计时</div>
				<div style="text-align: center;margin:20px 0 10px;">
					<el-progress v-if="detail.status===2||detail.status===-2" :stroke-width="15" type="circle" :percentage="100" :format="()=>{return '审核完成'}"></el-progress>
					<el-progress v-else :stroke-width="15" type="circle" :percentage="$public.chu($public.cheng(progress.onlyDay,100),progress.totalDay)" :format="()=>{return progress.onlyDay+'天'}"></el-progress>
				</div>
				<div style="display: flex;justify-content: center;"
				v-if="(detail.approve_Records.length>0)&&(stepsActive-2)<(detail.approve_Records.length)&&detail.approve_Records[stepsActive-2].receive_id===userInfo.staffId&&(detail.status!==2&&detail.status!==-2)"
				>
					<el-button size="small" type="primary" style="margin-right: 25px;" @click="openRemark(2)">同意退款</el-button>
					<el-button size="small" type="primary" plain @click="openRemark(-2)">拒绝退款</el-button>
				</div>
				<div style="display: flex;justify-content: center;" v-else>
					<span v-if="detail.status===0" style="color:#1890FF">待审批</span>
					<span v-if="detail.status===1">审批中</span>
					<span v-if="detail.status===2">已同意</span>
					<span v-if="detail.status===-2" style="color:red">已拒绝</span>
				</div>
			</div>
			<div class="box2">
				<div class="tit">订单信息</div>
				<div v-if="detail.refundFlow._id==='61148aa78170596bbeacd166'">
					<div style="margin:80px;text-align: center;font-size: 14px;">余额退款无原始订单信息</div>
				</div>
				<div v-else style="margin: 10px 5px;line-height: 34px;">
					<el-row>
						<el-col :span="8">
							<span class="label">订单类型:</span>
							<span class="value">
								<!-- 通用 -->
								<span v-if="detail.refundFlow._id==='60ee43d98170592e847a9bac'">
									{{detail.order.order_type}}
								</span>
								<!-- 充值 押金 -->
								<span v-else>
									<span v-if="detail.order.order_source===2">余额充值</span>
									<span v-if="detail.order.order_source===3">押金充值</span>
								</span>
							</span>
						</el-col>
						<el-col :span="8">
							<span class="label">订单状态:</span>
							<span class="value">
								<!-- 通用 -->
								<span v-if="detail.refundFlow._id==='60ee43d98170592e847a9bac'">
									{{$dict.getOrderStateNameById(detail.order.state)}}
								</span>
								<!-- 充值 押金 -->
								<span v-else>
									{{$dict.getOrderStateNameById(detail.order.state)}}
								</span>
							</span>
						</el-col>
						<el-col :span="8">
							<span class="label">结算方式:</span>
							<span class="value">
								<span v-if="detail.order.pay_info">
									<span style="padding-right: 30px;" v-for="(item,index) in detail.order.pay_info.pay_list" :key="index">
										<span style="padding-right: 2px;">
											{{$dict.getPaymentMethodNameById(item.pay_type)}}
										</span>
										{{item.money}}
									</span>
								</span>
							</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="label">订单编号:</span>
							<span class="value">
								{{detail.order.no}}
							</span>
						</el-col>
						<el-col :span="8">
							<span class="label">订单总计:</span>
							<span class="value">
								<!-- 通用 -->
								<span v-if="detail.refundFlow._id==='60ee43d98170592e847a9bac'">
									{{detail.order.total_price}}
								</span>
								<!-- 充值 押金 -->
								<span v-else>
									{{detail.order.price}}
								</span>
							</span>
						</el-col>
						<el-col :span="8">
							<span class="label">创建人:</span>
							<span class="value">
								{{detail.order.create_manager_name}}
							</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="label">创建时间:</span>
							<span class="value">
								{{$public.FTime(detail.order.create_time)}}
							</span>
						</el-col>
						<el-col :span="16">
							<span class="label">订单备注:</span>
							<span class="value">
								{{detail.order.remark}}
							</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="label">顾客名称:</span>
							<span class="value">
								{{detail.order.user_info.nick_name}}
							</span>
						</el-col>
						<el-col :span="8">
							<span class="label">顾客电话:</span>
							<span class="value">
								{{detail.order.user_info.user_mobile}}
							</span>
						</el-col>
						<el-col :span="8">
							<span class="label">结算时间:</span>
							<span class="value">
								{{$public.FTime(detail.order.pay_info.pay_time)}}
							</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="8">
							<span class="label">顾客宠物:</span>
							<span class="value">
								<span v-if="detail.order._id">
									<!-- 通用 -->
									<span v-if="detail.refundFlow._id==='60ee43d98170592e847a9bac'">
										{{
											detail.order.order_item_list.length>0?
											detail.order.order_item_list[0].pets_info&&detail.order.order_item_list[0].pets_info.pets_name:
											''
										}}
									</span>
									<!-- 充值 押金 -->
									<span v-else>
										{{
											detail.order.recharge_item_list.length>0?
											detail.order.recharge_item_list[0].pets_info&&detail.order.recharge_item_list[0].pets_info.pets_name:
											''
										}}
									</span>
								</span>
							</span>
						</el-col>
						<el-col :span="16">
							<span class="label">结算备注:</span>
							<span class="value">
								{{detail.order.pay_info.pay_remark}}
							</span>
						</el-col>
					</el-row>
				</div>
			</div>
			<div class="box3">
				<div class="tit">退款订单信息</div>
				<div style="margin: 10px 5px;line-height: 34px;">
					<el-row>
						<el-col :span="15">
							<span class="label">退款编号:</span>
							<span class="value">
								{{detail.refundOrder.no}}
							</span>
						</el-col>
						<el-col :span="9">
							<span class="label">退款金额:</span>
							<span class="value">
								{{detail.refundOrder.total_price}}
							</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="15">
							<span class="label">发起人:</span>
							<span class="value">
								{{detail.refundOrder.create_user_name}}
							</span>
						</el-col>
						<el-col :span="9">
							<span class="label">退换状态:</span>
							<span class="value">
								{{$dict.getReturnOrderStateNameById(detail.refundOrder.state)}}
							</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="15">
							<span class="label">退换方式:</span>
							<span class="value">
								<span v-if="detail.refundOrder.pay_info">
									<span style="padding-right: 30px;" v-for="(item,index) in detail.refundOrder.pay_info.pay_list" :key="index">
										<span style="padding-right: 2px;">
											{{$dict.getPaymentMethodNameById(item.pay_type)}}
										</span>
										{{item.money}}
									</span>
								</span>
							</span>
						</el-col>
						<el-col :span="9">
							<span class="label">是否入库:</span>
							<span class="value">
								{{detail.refundOrder.is_into?'是':''}}
								{{!detail.refundOrder.is_into?'否':''}}
							</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="15">
							<span class="label">发起时间:</span>
							<span class="value">
								{{$public.FTime(detail.refundOrder.create_time)}}
							</span>
						</el-col>
						<el-col :span="9">
							<span class="label">退换地点:</span>
							<span class="value">
								{{$dict.getShopNameById(detail.refundOrder.company_info.shop_id)}}
							</span>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="24">
							<span class="label" style="vertical-align: top;">退款备注:</span>
							<span  v-if="detail.refundOrder.remark" class="value" style="width: 213px;overflow: hidden;display: inline-block;margin-left:5px;">
								<el-tooltip effect="dark" :content="detail.refundOrder.remark" placement="top-start">
									<div style="width:100%;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{detail.refundOrder.remark}}</div>
								</el-tooltip>
							</span>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<div class="lineBox lineBox1">
			<div class="box4" style="height: 100%;padding:20px 20px 10% 20px;box-sizing: border-box;">
				<el-steps direction="vertical" :active="stepsActive" v-if="detail.approve_Records.length>0">
					<el-step >
						<!-- 2: 通过  -2 拒绝  0审批中 -->
						<span slot="title">发起人</span>
						<span slot="description">{{detail.operation_info.create.create_user.user_name}}</span>
					</el-step>
					<el-step v-for="(item,index) in detail.approve_Records" :key="item._id">
						<span slot="title" v-if="stepsActive===index+2">审核中</span>
						<span slot="title" v-else>审核人</span>
						<span slot="description">
							{{item.receive_name}}
							<span v-if="item.status===2">( 通过 )</span>
							<span v-if="item.status===-2" style="color:red;">
								( 拒绝 {{item.remark}})
							</span>
						</span>
					</el-step>
					<el-step>
						<span slot="title">抄送人</span>
						<span slot="description">
							<span style="margin:0 5px;" v-for="item in detail.copy_Records" :key="item._id">{{item.receive_name}}</span>
						</span>
					</el-step>
				</el-steps>
			</div>
			<div class="box5">
				<el-table :data="detail.refundOrder.return_item_list" style="width: 100%">
					<el-table-column type="expand">
						<template slot-scope="props">
							<div >
								<div v-if="!$public.isNull(props.row.order_item_goods_list)">
									<el-tag style="margin: 5px;" v-for="item in props.row.order_item_goods_list" :key="item.goods_name+Math.random()">
										<span v-if="props.row.goodsType===8">{{item.goods_name}} {{item.model}}</span>
										{{item.custom_code}}
									</el-tag>
								</div>
								<div v-else>无条码</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="商品" prop="careId" >
						<template slot-scope="props">
							<span>{{props.row.goods_name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="规格" prop="careId" >
						<template slot-scope="props">
							<span>{{props.row.sku_value}}</span>
						</template>
					</el-table-column>
					<el-table-column label="标准价" prop="careId" >
						<template slot-scope="props">
							<span>{{props.row.original_price}}</span>
						</template>
					</el-table-column>
					<el-table-column label="活动" prop="careId" >
						<template slot-scope="props">
							<span>{{props.row.activity_info&&props.row.activity_info.activity_name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="优惠价" prop="careId" >
						<template slot-scope="props">
							<span>{{props.row.price}}</span>
						</template>
					</el-table-column>
					<el-table-column label="数量" prop="careId" >
						<template slot-scope="props">
							<span>{{props.row.num}}</span>
						</template>
					</el-table-column>
					<el-table-column label="总金额" prop="careId" >
						<template slot-scope="props">
							<span>{{$public.cheng(props.row.price,props.row.num)}}</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data(){
			return{
				detail:{
					approve_Records:[],
					refundFlow:{},
					copy_Records:{},
					refundOrder:{
						company_info:{},
						pay_info:{},
					}, 
					order:{
						user_info:{},
						pay_info:{},
						order_item_list:{},
						recharge_item_list:{},
						
					},
					operation_info:{
						create:{
							create_user:{},
						},
					},
				},
				progress:{
					totalDay:7,
					onlyDay:7,
				},
				stepsActive:0,
			}
		},
		watch:{
			
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			},
		},
		mounted(){
			this.getDetail()
		},
		methods: {
			getDetail(){
				let loading=this.$loading();
				this.$http.get(process.env.VUE_APP_member+'/api/middleware/RefundAudit/Info', {id:this.$route.query.id}).then(res => {
					loading.close()
					if (res.code == 0) {
						this.detail = res.data;
						this.progress.totalDay = this.detail.surplusDay;
						this.progress.onlyDay = this.$public.jian(this.detail.surplusDay,Number(this.detail.refundDays)||0);
						for(let i=0;i<this.detail.approve_Records.length;i++){
							if(this.detail.approve_Records[i].status===0){
								this.stepsActive = i+2;
								break;
							}
						}
						if(this.stepsActive===0){
							this.stepsActive = this.detail.approve_Records.length+2;
						}
					}
				})
			},
			openRemark(status){
				this.$prompt('请输入备注', '', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					inputPattern: '',
					inputErrorMessage: '输入有误'
				}).then(({ value }) => {
					if(status===2){
						this.agree(value)
					}else if(status===-2){
						this.disagree(value);
					}
				})
			},
			agree(remark){
				let params = {
					"id": this.$route.query.id,
					"status": 2, // 2通过 -2拒绝
					"remark": remark,
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_member+'/api/middleware/RefundAudit/agree', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getDetail();
					}
				})
			},
			disagree(remark){
				let params = {
					"id": this.$route.query.id,
					"status": -2, // 2通过 -2拒绝
					"remark": remark,
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_member+'/api/middleware/RefundAudit/refuse', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.$message({
							message: '操作成功',
							type: 'success'
						});
						this.getDetail();
					}
				})
			},
		}
	}
</script>
<style scoped lang="scss">
.page{
	padding: 16px 16px 65px 16px;
	height: 100%;
	box-sizing: border-box;
	position: relative;
	.titleBox{
		width:100%;height: 50px;border-radius: 4px;background-color: #fff;padding:0 16px;box-sizing: border-box;display: flex;justify-content: space-between;
		.title{
			color:#333;font-size: 14px;font-weight: 700;line-height: 50px;
		}
	}
	.lineBox{
		display: flex;justify-content: space-between;margin-top:10px;width:100%;
		.tit{
			font-size: 14px;color:#333;font-weight: 700;
		}
		.box1{
			height: 233px;background-color: #fff;width:251px;border-radius: 4px;padding:10px 15px;box-sizing: border-box;flex-shrink: 0;
		}
		.box2{
			height: 233px;background-color: #fff;width:651px;margin-left:10px;border-radius: 4px;padding:10px 15px;box-sizing: border-box;flex-shrink: 0;
			.label{
				font-size: 12px;color:#333;font-weight: 700;
			}
			.value{
				font-size: 12px;color:#666;
			}
		}
		.box3{
			height: 233px;background-color: #fff;width: 100%;margin-left:10px;border-radius: 4px;padding:10px 15px;box-sizing: border-box;
			.label{
				font-size: 12px;color:#333;font-weight: 700;
			}
			.value{
				font-size: 12px;color:#666;
			}
		}
		.box4{
			background-color: #fff;width:251px;border-radius: 4px;padding:10px 15px;box-sizing: border-box;flex-shrink: 0;
		}
		.box5{
			background-color: #fff;margin-left:10px;width: 100%;border-radius: 4px;
		}
	}
	.lineBox1{
		height: calc( 100% - 303px );
	}
}
</style>
